import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { DeleteUsers, getUserId, getOrgId, HEADERS } from '../api';

function DisableAccount() {
  const userId = getUserId();
  const orgId = getOrgId();
  const navigate = useNavigate();

  const handleDisableClick = async () => {
    try {
      const result = await Swal.fire({
        title: 'Disable Account',
        text: 'Are you sure you want to disable your account?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Disable',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      });

      const requestBody = {
        organization_id: orgId,
        user_id: userId,
      };

      if (result.isConfirmed) {
        const response = await axios.post(DeleteUsers, requestBody, { headers: HEADERS });
        // $&

        if (response.data.response_code === '0000') {
          const resultDisabled = await Swal.fire('Disabled!', 'Your account has been disabled.', 'success');
          if (resultDisabled.isConfirmed) {
            navigate('/Login');
          }

        } else {
          // Swal.fire('Error!', 'Failed to disable your account.', 'error');
          Swal.fire({
            icon: 'error',
            title: 'Failed!',
            text: `${response.data.response_description}`,
          });
        }
      }
    } catch (error) {
      console.error('Error disabling account:', error);
      Swal.fire('Error!', 'Failed to disable your account.', 'error');
    }
  };



  return (
    <div className="p-3">
      <h5>Disable Account</h5>
      <div className="disable">
        <div className="d-flex disable-forms pt-2">
          <button className="btn btn-danger" onClick={handleDisableClick}>
            Disable
          </button>
        </div>
        <span className="gap-span" style={{ display: 'flex', marginTop: '20px' }}>
          Disabling account will stop all activities in your Time Trek account. You will not be able to access Time Trek anymore.
        </span>
      </div>
    </div>

  );
}

export default DisableAccount;